"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextArea = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const theme_1 = require("@monorepo/theme");
exports.StyledTextArea = styled_components_1.default.textarea `
  width: 812px;
  height: 292px;

  background: ${theme_1.colors.white};

  font-size: 18px;
  font-family: 'ATTAleckSans';

  padding: 23px 18px;

  resize: none;

  ${({ withBorder }) => (withBorder ? '' : 'border: none;')}
`;
